import { DataManager } from '../../core/data-manager';



export async function onDelete(response, entity, id) {

    if(entity === 'customer_order' && response.success === 1) {
        deleteCustomerOrderRows(id)
    }
    if(entity === 'supplier_order' && response.success === 1) {
        deleteSupplierOrderRows(id)
    }

}

async function deleteCustomerOrderRows(id) {
    var constraints = [
        {
            "fieldName": "idCustomerOrder", 
            "type": "value",
            "value": id
        }
    ]
    var sorting = {
        'field': 'id',
        'order': 'desc'
    }
    var response = await DataManager.searchItems('customer_order_rows', 1, 100, sorting, '', [], constraints)
    console.warn(response)
    if(response.success === 1) {
        if(response.body.length) {
            var rows = response.body
            for(var i=0; i<rows.length; i++) {
                var deleteResponse = await DataManager.deleteItem('customer_order_rows', rows[i].id)
            }
        }
    }
}
async function deleteSupplierOrderRows(id) {
    var constraints = [
        {
            "fieldName": "idSupplierOrder", 
            "type": "value",
            "value": id
        }
    ]
    var sorting = {
        'field': 'id',
        'order': 'desc'
    }
    var response = await DataManager.searchItems('supplier_order_rows', 1, 100, sorting, '', [], constraints)
    console.warn(response)
    if(response.success === 1) {
        if(response.body.length) {
            var rows = response.body
            for(var i=0; i<rows.length; i++) {
                var deleteResponse = await DataManager.deleteItem('supplier_order_rows', rows[i].id)
            }
        }
    }
}